// import { Button, Col, Form, Input } from 'antd'
import { Row, Col, Form, Input, Button, Select } from 'antd'
import styles from './styles.module.scss'
import { removeVietnameseTones } from '../../config-func'
import { debounce } from 'lodash'
const SearchForm = ({ fetchData, handleSearch, setFilters, cities, districts, towns, onChangeCity, setDistricts, onChangeDistrict }) => {
  const [form] = Form.useForm()

  const handleReset = debounce(() => {
    form.resetFields()
    setDistricts([])
    fetchData({
      pageNo: 1,
      pageSize: 10
    })
  }, 300)

  return (
    <Form
      form={form}
      layout="vertical"
      onFinish={handleSearch}
      style={{ marginTop: 10 }}
      onValuesChange={(value, allValues) => {
        setFilters((prev) => ({ ...prev, ...allValues }))
      }}
    >
      <div
        style={{
          display: 'flex',
          flexWrap: 'wrap',
          gap: '16px',
          alignItems: 'center'
        }}
      >
        <div style={{ flex: '1 1 200px', minWidth: '200px' }}>
          <Form.Item label="Tên dự án" name="name">
            <Input placeholder="Nhập tên dự án" 
            onBlur={(e) => {
              form.setFields([
                {
                  name: 'name',
                  value: e.target.value?.trim()
                }
              ])
            }}
            />
          </Form.Item>
        </div>

        {/* Ô nhập tỉnh/thành phố */}
        <div style={{ flex: '1 1 200px', minWidth: '200px' }}>
          <Form.Item label="Tỉnh/Thành phố" name="city_code">
            <Select
            allowClear
              showSearch
              filterOption={(input, option) => {
                const inputValue = removeVietnameseTones(input).toLowerCase();
                const optionValue = removeVietnameseTones(option?.children || '').toLowerCase();
                return optionValue.includes(inputValue);
              }}
              placeholder={`Chọn tỉnh/thành phố`}
              onChange={onChangeCity}
            >
              {cities?.map((city) => {
                return (
                  <Select.Option key={city.code} value={city.code}>
                    {city.name}
                  </Select.Option>
                )
              })}
            </Select>
          </Form.Item>
        </div>

        <div style={{ flex: '1 1 200px', minWidth: '200px' }}>
          <Form.Item label="Quận huyện" name="district_code">
            <Select
            allowClear
              showSearch
              filterOption={(input, option) => {
                const inputValue = removeVietnameseTones(input).toLowerCase();
                const optionValue = removeVietnameseTones(option?.children || '').toLowerCase();
                return optionValue.includes(inputValue);
              }}
              onChange={onChangeDistrict}
              placeholder={`Chọn quận huyện`}
            >
              {districts?.map((city) => {
                return (
                  <Select.Option key={city.code} value={city.code}>
                    {city.name}
                  </Select.Option>
                )
              })}
            </Select>
          </Form.Item>
        </div>

        <div style={{ flex: '1 1 200px', minWidth: '200px' }}>
          <Form.Item label="Phường xã" name="town_code">
            <Select
              style={{ width: '100%' }}
              placeholder={`Chọn Phường xã`}
              showSearch={true}
              allowClear={true}
              filterOption={(input, option) => {
                const inputValue = removeVietnameseTones(input).toLowerCase()
                const optionValue = removeVietnameseTones(
                  option?.children || ''
                ).toLowerCase()
                return optionValue.includes(inputValue)
              }}
            >
              {towns.map((item, idx) => (
                <Option key={idx} value={item.value}>
                  {item.label}
                </Option>
              ))}
            </Select>
          </Form.Item>
        </div>
        <div style={{ flex: '1 1 200px', minWidth: '200px' }}>
          <Form.Item label="Đường phố" name="address">
          <Input
              placeholder="Nhập tên đường phố"
              onBlur={(e) => {
                form.setFields([
                  {
                    name: 'address',
                    value: e.target.value?.trim()
                  }
                ])
              }}
            />
          </Form.Item>
        </div>

        <div style={{ flex: '1 1 200px', minWidth: '200px' }}>
          <Form.Item label="Chủ đầu tư" name="owner_name">
            <Input placeholder="Nhập chủ đầu tư" 
            onBlur={(e) => {
              form.setFields([
                {
                  name: 'owner_name',
                  value: e.target.value?.trim()
                }
              ])
            }}
            />
          </Form.Item>
        </div>

        {/* Phần nút bấm */}
        <div
          style={{
            display: 'flex',
            gap: '8px',
            justifyContent: 'flex-end',
            flex: '1 1 200px',
            minWidth: '200px'
          }}
        >
          <Button onClick={handleReset}>Đặt lại</Button>
          <Button type="primary" htmlType="submit">
            Tìm kiếm
          </Button>
        </div>
      </div>
    </Form>
  )
}

export default SearchForm
